import { Megaphone } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { OnboardingAnnouncement, PublicUser } from "@forgepoint/shared";
import { AnnouncementItem } from "./AnnouncementItem";

interface AnnouncementsCardProps {
  announcements: OnboardingAnnouncement[];
  usersById: Map<string, PublicUser>;
}

/**
 * Messages from the Forgepoint team on the onboarding board, pinned posts
 * first, with the author's profile picture on the left and a Forgepoint
 * badge on staff-authored posts.
 */
export function AnnouncementsCard({
  announcements,
  usersById,
}: AnnouncementsCardProps) {
  if (announcements.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Megaphone className="h-4 w-4" />
          From the Forgepoint team
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-0">
        {announcements.map((announcement) => (
          <AnnouncementItem
            key={announcement.id}
            announcement={announcement}
            author={usersById.get(announcement.authorUserId)}
          />
        ))}
      </CardContent>
    </Card>
  );
}
